import axios from 'axios';
import { useEffect, useState } from 'react';
import Modal from '../../../interface/modal/Modal';
import useUrlParams from '../../../hook/useUrlParams';
import './photos.css'
import PhotoItems from './PhotoItems';
import LogoWhite from '../../../design/logo/LogoWhite';
import UseLang from '../../../hook/UseLang';
import BackButton from '../../goback/BackButton';

const Photos = () => {
    const [multimediaData, setMultimediaData] = useState([]);

    useEffect(() => {
        axios.get('https://apievt.lacnic.net/wp-json/data/multimedia/1803')
            .then(response => {
                setMultimediaData(response.data.acf.photos);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);
 

    const {  paramValue, display, closeModal } = useUrlParams('multimedia', ['photos'])

    return (
        <>
            <Modal onCancel={closeModal} show={display} paramValue={'multimedia'} className='photos' class_modal='photo_backdrop'>
                <div>
                    <button onClick={closeModal} className='button_photo_cancel'><i class="icon-xmark" aria-hidden="true"></i></button>
                    <LogoWhite/>
                    <h2><UseLang es>Fotos</UseLang><UseLang en>Fotos</UseLang><UseLang pt_br>Fotos</UseLang></h2>
                    {paramValue === 'photos' ? <>
                        {multimediaData?.map(item => (
                            <>{item.url ? 
                                <a className='button_photo_link' href={`${item.url}`} target='_blank' rel="noreferrer" key={item.id}>
                                    <PhotoItems item={`${item.date}`} />
                                </a> : 
                                <button className='button_photo_link'><PhotoItems item={`${item.date}`} /></button> 
                            }</>
                            
                    ))}
                    <BackButton className='button_photo_back' onClick={closeModal} />  
                    </>
                    : undefined}
                </div>
            </Modal>
        </>
    );
}

export default Photos;

